import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixPlayIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M4.45801 4.35705C4.45789 3.97267 4.5592 3.59507 4.7517 3.26237C4.9442 2.92967 5.22107 2.65365 5.55437 2.46219C5.88766 2.27072 6.26557 2.17058 6.64995 2.17189C7.03432 2.17319 7.41155 2.27589 7.74353 2.46962L20.8474 10.1133C21.1781 10.3052 21.4526 10.5805 21.6436 10.9117C21.8345 11.243 21.9352 11.6185 21.9355 12.0008C21.9359 12.3832 21.8359 12.7589 21.6455 13.0905C21.4551 13.422 21.181 13.6978 20.8507 13.8903L7.74353 21.5361C7.41155 21.7299 7.03432 21.8326 6.64995 21.8339C6.26557 21.8352 5.88766 21.735 5.55437 21.5436C5.22107 21.3521 4.9442 21.0761 4.7517 20.7434C4.5592 20.4107 4.45789 20.0331 4.45801 19.6487V4.35705Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
